import { Col, Form } from "antd";
import { LoadingDashboard, checkDataObject } from "pages/overview";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  useGetDashboardRepairingMostStatus,
  useGetDashboardRepairingSLA,
} from "service/dashboard/central/homecare";

const SLA = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const allStatusDate = Form.useWatch("repairDate");
  const repairYear = findDate(allStatusDate, "year");

  const dataSLA = useGetDashboardRepairingSLA({ ...repairYear, property });
  const dataStatus = useGetDashboardRepairingMostStatus({
    ...repairYear,
    property,
  });

  const findDataSLA = checkDataObject(dataSLA.data);
  const findDataStatus = checkDataObject(dataStatus.data);

  const countSlaCompletion = (
    findDataSLA?.countSlaCompletion || 0
  ).toLocaleString();

  const countSlaAppointment = (
    findDataSLA?.countSlaAppointment || 0
  ).toLocaleString();

  const waitingConfirmAppointment = (
    findDataStatus?.waitingConfirmAppointment || 0
  ).toLocaleString();

  return (
    <React.Fragment>
      <Col md={24} lg={24} xl={12}>
        <LoadingDashboard loading={dataSLA.isFetching}>
          <div className="bg-[#E9F7E6] text-[#21AA00] h-[250px] center flex-col !rounded-app">
            <div className="bg-[#E9F7E6] text-[#21AA00]">
              {t("waiting-for-appointment")}
            </div>
            <div className="text-[24px] mt-5">
              {waitingConfirmAppointment} {t("suite")}
            </div>
          </div>
        </LoadingDashboard>
      </Col>
      <Col md={24} lg={24} xl={12} className="h-[250px] !rounded-app">
        <LoadingDashboard loading={dataSLA.isFetching || dataStatus.isFetching}>
          <div className="bg-[#EAF5FF] text-[#2061E7] center h-[125px] flex-col rounded-t-app">
            <span>{t("sla-confirm-appointment")}</span>
            <div className="text-[24px] mt-2">{countSlaAppointment}</div>
          </div>
          <div className="bg-white text-[#081221] center h-[125px] flex-col rounded-b-app">
            <span>{t("sla-completion")}</span>
            <div className="text-[24px] mt-2">{countSlaCompletion}</div>
          </div>
        </LoadingDashboard>
      </Col>
    </React.Fragment>
  );
};
export default SLA;
